/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export { ApiError } from './core/ApiError';
export { OpenAPI } from './core/OpenAPI';

export type { ActiveAndArchiveListOfEmployeeDocumentResponse } from './models/ActiveAndArchiveListOfEmployeeDocumentResponse';
export type { ActiveSurveyForm } from './models/ActiveSurveyForm';
export type { AddBed } from './models/AddBed';
export type { AddDepartmentCategoryRequestBody } from './models/AddDepartmentCategoryRequestBody';
export type { AddDepartmentPhoneNumberRequestBody } from './models/AddDepartmentPhoneNumberRequestBody';
export type { AddDepartmentTitleRequestBody } from './models/AddDepartmentTitleRequestBody';
export type { AddRoom } from './models/AddRoom';
export type { AllSchedulePPD } from './models/AllSchedulePPD';
export type { AnniversaryEmployeeInfo } from './models/AnniversaryEmployeeInfo';
export type { AnniversaryListing } from './models/AnniversaryListing';
export type { Announcement } from './models/Announcement';
export type { AnnouncementList } from './models/AnnouncementList';
export type { AnnouncementResponse } from './models/AnnouncementResponse';
export type { approvDenyEmployeeDocumentRequest } from './models/approvDenyEmployeeDocumentRequest';
export type { Assignee } from './models/Assignee';
export type { Bed } from './models/Bed';
export type { Beds } from './models/Beds';
export type { Budget } from './models/Budget';
export type { BulkCreateEmployeeResponse } from './models/BulkCreateEmployeeResponse';
export type { CalendarCount } from './models/CalendarCount';
export type { CalendarEvent } from './models/CalendarEvent';
export type { CalendarEventList } from './models/CalendarEventList';
export type { CalendarEventType } from './models/CalendarEventType';
export type { CategoryBudget } from './models/CategoryBudget';
export type { Census } from './models/Census';
export type { ChatList } from './models/ChatList';
export type { ChatLists } from './models/ChatLists';
export type { Company } from './models/Company';
export type { CompanyBudgets } from './models/CompanyBudgets';
export type { CompanyExpense } from './models/CompanyExpense';
export type { CompanyExpenses } from './models/CompanyExpenses';
export type { CompanyGuardianAngel } from './models/CompanyGuardianAngel';
export type { CompanyGuardianAngels } from './models/CompanyGuardianAngels';
export type { CompanyInspectionPeriodUpdate } from './models/CompanyInspectionPeriodUpdate';
export type { CompanyList } from './models/CompanyList';
export type { CompanyPhysician } from './models/CompanyPhysician';
export type { CompanyPhysicians } from './models/CompanyPhysicians';
export type { CompanyStatistics } from './models/CompanyStatistics';
export type { Count } from './models/Count';
export type { CountCompanyDocumentResponse } from './models/CountCompanyDocumentResponse';
export type { CountEmployeeDocumentApprovalRequest } from './models/CountEmployeeDocumentApprovalRequest';
export type { CreateCustomEventMetricRequestBody } from './models/CreateCustomEventMetricRequestBody';
export type { CreateDepartmentRequestBody } from './models/CreateDepartmentRequestBody';
export type { CreateDocumentRequest } from './models/CreateDocumentRequest';
export type { CreateEmployeeRequestBody } from './models/CreateEmployeeRequestBody';
export type { CreateScheduleRequest } from './models/CreateScheduleRequest';
export type { CreateScheduleTransferRequest } from './models/CreateScheduleTransferRequest';
export type { CreateStandardEventMetricRequestBody } from './models/CreateStandardEventMetricRequestBody';
export type { CronJobResponse } from './models/CronJobResponse';
export type { CurrentActiveForm } from './models/CurrentActiveForm';
export type { DataDetail } from './models/DataDetail';
export type { Dataset } from './models/Dataset';
export type { Datum } from './models/Datum';
export type { DeleteDepartmentCategoryRequestBody } from './models/DeleteDepartmentCategoryRequestBody';
export type { Department } from './models/Department';
export type { DepartmentCategory } from './models/DepartmentCategory';
export type { DepartmentColor } from './models/DepartmentColor';
export type { DepartmentColors } from './models/DepartmentColors';
export type { DepartmentDocumentListResponse } from './models/DepartmentDocumentListResponse';
export type { DepartmentDocumentResponse } from './models/DepartmentDocumentResponse';
export type { DepartmentEmployeeAssignment } from './models/DepartmentEmployeeAssignment';
export type { DepartmentEventMetricsTrackingList } from './models/DepartmentEventMetricsTrackingList';
export type { DepartmentHasBudget } from './models/DepartmentHasBudget';
export type { DepartmentList } from './models/DepartmentList';
export type { DepartmentPhoneNumber } from './models/DepartmentPhoneNumber';
export type { DepartmentPhoneNumberRequestBody } from './models/DepartmentPhoneNumberRequestBody';
export type { DepartmentSchedulePPD } from './models/DepartmentSchedulePPD';
export type { DepartmentTitle } from './models/DepartmentTitle';
export type { DepartmentTitleOrderRequestObject } from './models/DepartmentTitleOrderRequestObject';
export type { DepartmentTitleRequestObject } from './models/DepartmentTitleRequestObject';
export type { Detail } from './models/Detail';
export type { Details } from './models/Details';
export type { DocumentListResponse } from './models/DocumentListResponse';
export type { DocumentName } from './models/DocumentName';
export type { DocumentPathResponse } from './models/DocumentPathResponse';
export type { DocumentResponse } from './models/DocumentResponse';
export type { Employee } from './models/Employee';
export type { EmployeeDocumentByDocumentIdResponse } from './models/EmployeeDocumentByDocumentIdResponse';
export type { EmployeeDocumentListResponse } from './models/EmployeeDocumentListResponse';
export type { EmployeeDocumentResponse } from './models/EmployeeDocumentResponse';
export type { EmployeeEventScore } from './models/EmployeeEventScore';
export type { EmployeeFiveStarScore } from './models/EmployeeFiveStarScore';
export type { EmployeeId } from './models/EmployeeId';
export type { EmployeeList } from './models/EmployeeList';
export type { EmployeeListing } from './models/EmployeeListing';
export type { EmployeeRanking } from './models/EmployeeRanking';
export type { EmployeeScheduleReport } from './models/EmployeeScheduleReport';
export type { EmployeeSchedules } from './models/EmployeeSchedules';
export type { Error } from './models/Error';
export type { ErrorResponse } from './models/ErrorResponse';
export type { EventCount } from './models/EventCount';
export type { EventLineChart } from './models/EventLineChart';
export type { EventMetric } from './models/EventMetric';
export type { EventMetricList } from './models/EventMetricList';
export type { ExpansionNavigationItem } from './models/ExpansionNavigationItem';
export type { Expense } from './models/Expense';
export type { ExpenseList } from './models/ExpenseList';
export type { ExpirationNotification } from './models/ExpirationNotification';
export type { FacilityStatistics } from './models/FacilityStatistics';
export type { FavoriteCategories } from './models/FavoriteCategories';
export type { FavoriteCategory } from './models/FavoriteCategory';
export type { FavoriteItem } from './models/FavoriteItem';
export type { FavoriteItems } from './models/FavoriteItems';
export type { FCMTokenRequest } from './models/FCMTokenRequest';
export type { FCMTokenResponse } from './models/FCMTokenResponse';
export type { Floor } from './models/Floor';
export type { FloorOrder } from './models/FloorOrder';
export type { Floors } from './models/Floors';
export type { Form } from './models/Form';
export type { Forms } from './models/Forms';
export type { FullPatientCalendar } from './models/FullPatientCalendar';
export type { FullPatientCalendarEvents } from './models/FullPatientCalendarEvents';
export type { GetDepartmentCategoriesRequestBody } from './models/GetDepartmentCategoriesRequestBody';
export type { GetDepartmentTitlesRequestBody } from './models/GetDepartmentTitlesRequestBody';
export type { GetDepartmentTitlesResponseBody } from './models/GetDepartmentTitlesResponseBody';
export type { getEmployeeDocumentByAprovalRequest } from './models/getEmployeeDocumentByAprovalRequest';
export type { GetRecentlyJoinedEmployeesResponseBody } from './models/GetRecentlyJoinedEmployeesResponseBody';
export type { GetTarfRequestDetailResponse } from './models/GetTarfRequestDetailResponse';
export type { GetTarfRequestsListResponseBody } from './models/GetTarfRequestsListResponseBody';
export type { GetTarfRequestStatusesResponse } from './models/GetTarfRequestStatusesResponse';
export type { GroupAdmin } from './models/GroupAdmin';
export type { GroupParticipants } from './models/GroupParticipants';
export type { GuardianAngel } from './models/GuardianAngel';
export type { GuardianAngelResponse } from './models/GuardianAngelResponse';
export type { GuardianAngels } from './models/GuardianAngels';
export type { Handbook } from './models/Handbook';
export type { HandbookCategory } from './models/HandbookCategory';
export type { HandbookCategoryDetails } from './models/HandbookCategoryDetails';
export type { HandbookCategoryResponse } from './models/HandbookCategoryResponse';
export type { HandbookCategoryResponseList } from './models/HandbookCategoryResponseList';
export type { HandbookSubCategory } from './models/HandbookSubCategory';
export type { IdName } from './models/IdName';
export type { Inspection } from './models/Inspection';
export type { InspectionDashboardReport } from './models/InspectionDashboardReport';
export type { InspectionData } from './models/InspectionData';
export type { InspectionRequest } from './models/InspectionRequest';
export type { InspectionSummaries } from './models/InspectionSummaries';
export type { InspectionSummary } from './models/InspectionSummary';
export type { ItemMissed } from './models/ItemMissed';
export type { LeastEmployeeDocument } from './models/LeastEmployeeDocument';
export type { LikelyBenefit } from './models/LikelyBenefit';
export type { LikelyBenefits } from './models/LikelyBenefits';
export type { ListAvailableNumber } from './models/ListAvailableNumber';
export type { ListedAnniversary } from './models/ListedAnniversary';
export type { ListedEmployee } from './models/ListedEmployee';
export type { ListEmployeeWithHourSchedule } from './models/ListEmployeeWithHourSchedule';
export type { ListMessageResponse } from './models/ListMessageResponse';
export type { LogEventRequestBody } from './models/LogEventRequestBody';
export type { LoggedEvent } from './models/LoggedEvent';
export type { LoggedEventList } from './models/LoggedEventList';
export type { LoggedEventRecipient } from './models/LoggedEventRecipient';
export type { MaintenanceRequest } from './models/MaintenanceRequest';
export type { MaintenanceRequestResponse } from './models/MaintenanceRequestResponse';
export type { MeEventScoresResponse } from './models/MeEventScoresResponse';
export type { MeRankingResponse } from './models/MeRankingResponse';
export type { Message } from './models/Message';
export type { MessageFile } from './models/MessageFile';
export type { MessageGroup } from './models/MessageGroup';
export type { MessageGroupDetails } from './models/MessageGroupDetails';
export type { MessageGroupList } from './models/MessageGroupList';
export type { MessageGroupRequest } from './models/MessageGroupRequest';
export type { Messages } from './models/Messages';
export type { NavigationItem } from './models/NavigationItem';
export type { NavigationRailItem } from './models/NavigationRailItem';
export type { NavigationSubItem } from './models/NavigationSubItem';
export type { NotifyOnEmployeeDocument } from './models/NotifyOnEmployeeDocument';
export type { NotifyOnEmployeeDocumentResponse } from './models/NotifyOnEmployeeDocumentResponse';
export type { OwnerViewDocumentResponse } from './models/OwnerViewDocumentResponse';
export type { PaginatedMaintenanceResponse } from './models/PaginatedMaintenanceResponse';
export type { PatientCalendar } from './models/PatientCalendar';
export type { PatientCensus } from './models/PatientCensus';
export type { PostBudget } from './models/PostBudget';
export type { PPDDetail } from './models/PPDDetail';
export type { PPDRow } from './models/PPDRow';
export type { ProvisionCompanyRequestBody } from './models/ProvisionCompanyRequestBody';
export type { PurchaseNumber } from './models/PurchaseNumber';
export type { Question } from './models/Question';
export type { Questions } from './models/Questions';
export type { RecentlyJoinedGroupedMonth } from './models/RecentlyJoinedGroupedMonth';
export type { Record } from './models/Record';
export type { RegisterAccountRequestBody } from './models/RegisterAccountRequestBody';
export type { ResponseForm } from './models/ResponseForm';
export type { ResponseQuestion } from './models/ResponseQuestion';
export type { ResponseSatisfactionSurveyData } from './models/ResponseSatisfactionSurveyData';
export type { ResponseSurveyData } from './models/ResponseSurveyData';
export type { ResponseSurveyQuestion } from './models/ResponseSurveyQuestion';
export type { ResponseTask } from './models/ResponseTask';
export type { ReviewTarfRequestByOwnerRequestBody } from './models/ReviewTarfRequestByOwnerRequestBody';
export type { ReviewTarfRequestRequestBody } from './models/ReviewTarfRequestRequestBody';
export type { Room } from './models/Room';
export type { RoomGuardianAngel } from './models/RoomGuardianAngel';
export type { RoomOrder } from './models/RoomOrder';
export type { Rooms } from './models/Rooms';
export type { RoomsStatus } from './models/RoomsStatus';
export type { RoomStatus } from './models/RoomStatus';
export type { RoomStatusCount } from './models/RoomStatusCount';
export type { RoomStatusCounts } from './models/RoomStatusCounts';
export type { SatisfactionOverview } from './models/SatisfactionOverview';
export type { SatisfactionOverviewDetails } from './models/SatisfactionOverviewDetails';
export type { SatisfactionSurvey } from './models/SatisfactionSurvey';
export type { SatisfactionSurveyActiveForm } from './models/SatisfactionSurveyActiveForm';
export type { SatisfactionSurveyData } from './models/SatisfactionSurveyData';
export type { SatisfactionSurveyDataResponse } from './models/SatisfactionSurveyDataResponse';
export type { SatisfactionSurveyDetail } from './models/SatisfactionSurveyDetail';
export type { SatisfactionSurveyForm } from './models/SatisfactionSurveyForm';
export type { SatisfactionSurveyQuestion } from './models/SatisfactionSurveyQuestion';
export type { SatisfactionSurveyQuestions } from './models/SatisfactionSurveyQuestions';
export type { SatisfactionSurveyRequest } from './models/SatisfactionSurveyRequest';
export type { SatisfactionSurveySummary } from './models/SatisfactionSurveySummary';
export type { Schedule } from './models/Schedule';
export type { ScheduleCallOff } from './models/ScheduleCallOff';
export type { ScheduleChartData } from './models/ScheduleChartData';
export type { ScheduleDailyReport } from './models/ScheduleDailyReport';
export type { ScheduleDailyTitleReport } from './models/ScheduleDailyTitleReport';
export type { SchedulePPD } from './models/SchedulePPD';
export type { ScheduleSetting } from './models/ScheduleSetting';
export { ScheduleStatus } from './models/ScheduleStatus';
export type { ScheduleTimeOff } from './models/ScheduleTimeOff';
export type { ScheduleTimeOffRejectRequest } from './models/ScheduleTimeOffRejectRequest';
export type { ScheduleTimeOffRequest } from './models/ScheduleTimeOffRequest';
export type { ScheduleTimeOffUpdateRequest } from './models/ScheduleTimeOffUpdateRequest';
export type { ScheduleTransfer } from './models/ScheduleTransfer';
export { ScheduleTransferStatus } from './models/ScheduleTransferStatus';
export type { ScoreboardBreakdown } from './models/ScoreboardBreakdown';
export type { ScoreboardBreakdownEmployeeScores } from './models/ScoreboardBreakdownEmployeeScores';
export type { ScoreboardEventBreakdown } from './models/ScoreboardEventBreakdown';
export type { ScoreboardEventBreakdownDates } from './models/ScoreboardEventBreakdownDates';
export type { ScoreboardEventBreakdownEmployeeScore } from './models/ScoreboardEventBreakdownEmployeeScore';
export type { ScoreboardEventBreakdownListDates } from './models/ScoreboardEventBreakdownListDates';
export type { ScoreboardSummary } from './models/ScoreboardSummary';
export type { ScoreboardSummaryList } from './models/ScoreboardSummaryList';
export type { ScoreboardSummaryScore } from './models/ScoreboardSummaryScore';
export type { SendPasswordResetLinkResponse } from './models/SendPasswordResetLinkResponse';
export type { SendResetPasswordLinkBySelfRequest } from './models/SendResetPasswordLinkBySelfRequest';
export type { SendScheduleSMSResponse } from './models/SendScheduleSMSResponse';
export type { SetCompanyFeatureRequest } from './models/SetCompanyFeatureRequest';
export type { SettingsPayload } from './models/SettingsPayload';
export type { Shift } from './models/Shift';
export type { ShiftBid } from './models/ShiftBid';
export { ShiftBidStatus } from './models/ShiftBidStatus';
export type { ShiftBidWithSchedule } from './models/ShiftBidWithSchedule';
export type { SmsMessage } from './models/SmsMessage';
export type { SortDepartmentTitlesRequestBody } from './models/SortDepartmentTitlesRequestBody';
export type { StaffSurveyCategory } from './models/StaffSurveyCategory';
export type { StaffSurveyCodeRequest } from './models/StaffSurveyCodeRequest';
export type { StaffSurveyDataForDetails } from './models/StaffSurveyDataForDetails';
export type { StaffSurveyForm } from './models/StaffSurveyForm';
export type { StaffSurveyFormQuestion } from './models/StaffSurveyFormQuestion';
export type { StaffSurveyFormResponse } from './models/StaffSurveyFormResponse';
export type { StaffSurveyOverview } from './models/StaffSurveyOverview';
export type { StaffSurveyOverviewDetail } from './models/StaffSurveyOverviewDetail';
export type { StaffSurveyQuestion } from './models/StaffSurveyQuestion';
export type { StaffSurveyQuestionAndAnswer } from './models/StaffSurveyQuestionAndAnswer';
export type { StaffSurveyQuestionForDetails } from './models/StaffSurveyQuestionForDetails';
export type { StaffSurveyQuestionList } from './models/StaffSurveyQuestionList';
export type { StaffSurveyQuestionOption } from './models/StaffSurveyQuestionOption';
export type { StaffSurveyQuestionWithOptions } from './models/StaffSurveyQuestionWithOptions';
export type { StaffSurveyResponseData } from './models/StaffSurveyResponseData';
export type { StaffSurveyResponseWithDetails } from './models/StaffSurveyResponseWithDetails';
export type { StaffSurveySubmission } from './models/StaffSurveySubmission';
export type { StaffSurveySubmissionDetails } from './models/StaffSurveySubmissionDetails';
export type { StaffSurveySubmissionWithCode } from './models/StaffSurveySubmissionWithCode';
export type { StaffSurveySubmissionWithResponses } from './models/StaffSurveySubmissionWithResponses';
export type { Statistics } from './models/Statistics';
export type { SubStatistics } from './models/SubStatistics';
export type { Suggestion } from './models/Suggestion';
export type { SuggestionAnswer } from './models/SuggestionAnswer';
export type { SuggestionQuestion } from './models/SuggestionQuestion';
export type { SuggestionQuestions } from './models/SuggestionQuestions';
export type { Suggestions } from './models/Suggestions';
export type { SurveyData } from './models/SurveyData';
export type { SurveyDataDetail } from './models/SurveyDataDetail';
export type { SurveyDetail } from './models/SurveyDetail';
export type { SurveyOverviewDetail } from './models/SurveyOverviewDetail';
export type { SurveyOverviewDetails } from './models/SurveyOverviewDetails';
export type { SurveyQuestion } from './models/SurveyQuestion';
export type { SurveyQuestions } from './models/SurveyQuestions';
export type { SurveyRequest } from './models/SurveyRequest';
export type { SurveySummary } from './models/SurveySummary';
export type { TarfDetail } from './models/TarfDetail';
export type { TarfEditRequestBody } from './models/TarfEditRequestBody';
export type { TarfListItem } from './models/TarfListItem';
export type { TarfReason } from './models/TarfReason';
export type { TarfReasonsResponseBody } from './models/TarfReasonsResponseBody';
export type { TarfRequestRequestBody } from './models/TarfRequestRequestBody';
export type { TarfRequestsGroupedMonth } from './models/TarfRequestsGroupedMonth';
export type { TarfRequestsGroupedYear } from './models/TarfRequestsGroupedYear';
export type { TarfResubmitRequestBody } from './models/TarfResubmitRequestBody';
export type { TarfStatusDetail } from './models/TarfStatusDetail';
export type { Task } from './models/Task';
export type { Tasks } from './models/Tasks';
export type { TermsAndCondition } from './models/TermsAndCondition';
export type { TermsAndConditionList } from './models/TermsAndConditionList';
export type { TermsAndConditionListRequest } from './models/TermsAndConditionListRequest';
export type { TermsAndConditionRequest } from './models/TermsAndConditionRequest';
export type { TestNotificationRequest } from './models/TestNotificationRequest';
export type { TestNotificationResponse } from './models/TestNotificationResponse';
export { TimeOffStatus } from './models/TimeOffStatus';
export type { TitleSchedulePPD } from './models/TitleSchedulePPD';
export type { ToggleLoggedEventRequestBody } from './models/ToggleLoggedEventRequestBody';
export type { Track } from './models/Track';
export type { TrackedEventMetricsByDepartment } from './models/TrackedEventMetricsByDepartment';
export type { TrackRecords } from './models/TrackRecords';
export type { TransferEmployeeToDepartmentRequest } from './models/TransferEmployeeToDepartmentRequest';
export type { UnattendedRooms } from './models/UnattendedRooms';
export type { UnreadCount } from './models/UnreadCount';
export type { UpdateCompanyEmployeeRolesRequest } from './models/UpdateCompanyEmployeeRolesRequest';
export type { UpdateEmployeeProfileRequest } from './models/UpdateEmployeeProfileRequest';
export type { UpdateScheduleTransferStatusRequest } from './models/UpdateScheduleTransferStatusRequest';
export type { Vacation } from './models/Vacation';
export type { VacationListResponse } from './models/VacationListResponse';
export type { VacationRequest } from './models/VacationRequest';

export { $ActiveAndArchiveListOfEmployeeDocumentResponse } from './schemas/$ActiveAndArchiveListOfEmployeeDocumentResponse';
export { $ActiveSurveyForm } from './schemas/$ActiveSurveyForm';
export { $AddBed } from './schemas/$AddBed';
export { $AddDepartmentCategoryRequestBody } from './schemas/$AddDepartmentCategoryRequestBody';
export { $AddDepartmentPhoneNumberRequestBody } from './schemas/$AddDepartmentPhoneNumberRequestBody';
export { $AddDepartmentTitleRequestBody } from './schemas/$AddDepartmentTitleRequestBody';
export { $AddRoom } from './schemas/$AddRoom';
export { $AllSchedulePPD } from './schemas/$AllSchedulePPD';
export { $AnniversaryEmployeeInfo } from './schemas/$AnniversaryEmployeeInfo';
export { $AnniversaryListing } from './schemas/$AnniversaryListing';
export { $Announcement } from './schemas/$Announcement';
export { $AnnouncementList } from './schemas/$AnnouncementList';
export { $AnnouncementResponse } from './schemas/$AnnouncementResponse';
export { $approvDenyEmployeeDocumentRequest } from './schemas/$approvDenyEmployeeDocumentRequest';
export { $Assignee } from './schemas/$Assignee';
export { $Bed } from './schemas/$Bed';
export { $Beds } from './schemas/$Beds';
export { $Budget } from './schemas/$Budget';
export { $BulkCreateEmployeeResponse } from './schemas/$BulkCreateEmployeeResponse';
export { $CalendarCount } from './schemas/$CalendarCount';
export { $CalendarEvent } from './schemas/$CalendarEvent';
export { $CalendarEventList } from './schemas/$CalendarEventList';
export { $CalendarEventType } from './schemas/$CalendarEventType';
export { $CategoryBudget } from './schemas/$CategoryBudget';
export { $Census } from './schemas/$Census';
export { $ChatList } from './schemas/$ChatList';
export { $ChatLists } from './schemas/$ChatLists';
export { $Company } from './schemas/$Company';
export { $CompanyBudgets } from './schemas/$CompanyBudgets';
export { $CompanyExpense } from './schemas/$CompanyExpense';
export { $CompanyExpenses } from './schemas/$CompanyExpenses';
export { $CompanyGuardianAngel } from './schemas/$CompanyGuardianAngel';
export { $CompanyGuardianAngels } from './schemas/$CompanyGuardianAngels';
export { $CompanyInspectionPeriodUpdate } from './schemas/$CompanyInspectionPeriodUpdate';
export { $CompanyList } from './schemas/$CompanyList';
export { $CompanyPhysician } from './schemas/$CompanyPhysician';
export { $CompanyPhysicians } from './schemas/$CompanyPhysicians';
export { $CompanyStatistics } from './schemas/$CompanyStatistics';
export { $Count } from './schemas/$Count';
export { $CountCompanyDocumentResponse } from './schemas/$CountCompanyDocumentResponse';
export { $CountEmployeeDocumentApprovalRequest } from './schemas/$CountEmployeeDocumentApprovalRequest';
export { $CreateCustomEventMetricRequestBody } from './schemas/$CreateCustomEventMetricRequestBody';
export { $CreateDepartmentRequestBody } from './schemas/$CreateDepartmentRequestBody';
export { $CreateDocumentRequest } from './schemas/$CreateDocumentRequest';
export { $CreateEmployeeRequestBody } from './schemas/$CreateEmployeeRequestBody';
export { $CreateScheduleRequest } from './schemas/$CreateScheduleRequest';
export { $CreateScheduleTransferRequest } from './schemas/$CreateScheduleTransferRequest';
export { $CreateStandardEventMetricRequestBody } from './schemas/$CreateStandardEventMetricRequestBody';
export { $CronJobResponse } from './schemas/$CronJobResponse';
export { $CurrentActiveForm } from './schemas/$CurrentActiveForm';
export { $DataDetail } from './schemas/$DataDetail';
export { $Dataset } from './schemas/$Dataset';
export { $Datum } from './schemas/$Datum';
export { $DeleteDepartmentCategoryRequestBody } from './schemas/$DeleteDepartmentCategoryRequestBody';
export { $Department } from './schemas/$Department';
export { $DepartmentCategory } from './schemas/$DepartmentCategory';
export { $DepartmentColor } from './schemas/$DepartmentColor';
export { $DepartmentColors } from './schemas/$DepartmentColors';
export { $DepartmentDocumentListResponse } from './schemas/$DepartmentDocumentListResponse';
export { $DepartmentDocumentResponse } from './schemas/$DepartmentDocumentResponse';
export { $DepartmentEmployeeAssignment } from './schemas/$DepartmentEmployeeAssignment';
export { $DepartmentEventMetricsTrackingList } from './schemas/$DepartmentEventMetricsTrackingList';
export { $DepartmentHasBudget } from './schemas/$DepartmentHasBudget';
export { $DepartmentList } from './schemas/$DepartmentList';
export { $DepartmentPhoneNumber } from './schemas/$DepartmentPhoneNumber';
export { $DepartmentPhoneNumberRequestBody } from './schemas/$DepartmentPhoneNumberRequestBody';
export { $DepartmentSchedulePPD } from './schemas/$DepartmentSchedulePPD';
export { $DepartmentTitle } from './schemas/$DepartmentTitle';
export { $DepartmentTitleOrderRequestObject } from './schemas/$DepartmentTitleOrderRequestObject';
export { $DepartmentTitleRequestObject } from './schemas/$DepartmentTitleRequestObject';
export { $Detail } from './schemas/$Detail';
export { $Details } from './schemas/$Details';
export { $DocumentListResponse } from './schemas/$DocumentListResponse';
export { $DocumentName } from './schemas/$DocumentName';
export { $DocumentPathResponse } from './schemas/$DocumentPathResponse';
export { $DocumentResponse } from './schemas/$DocumentResponse';
export { $Employee } from './schemas/$Employee';
export { $EmployeeDocumentByDocumentIdResponse } from './schemas/$EmployeeDocumentByDocumentIdResponse';
export { $EmployeeDocumentListResponse } from './schemas/$EmployeeDocumentListResponse';
export { $EmployeeDocumentResponse } from './schemas/$EmployeeDocumentResponse';
export { $EmployeeEventScore } from './schemas/$EmployeeEventScore';
export { $EmployeeFiveStarScore } from './schemas/$EmployeeFiveStarScore';
export { $EmployeeId } from './schemas/$EmployeeId';
export { $EmployeeList } from './schemas/$EmployeeList';
export { $EmployeeListing } from './schemas/$EmployeeListing';
export { $EmployeeRanking } from './schemas/$EmployeeRanking';
export { $EmployeeScheduleReport } from './schemas/$EmployeeScheduleReport';
export { $EmployeeSchedules } from './schemas/$EmployeeSchedules';
export { $Error } from './schemas/$Error';
export { $ErrorResponse } from './schemas/$ErrorResponse';
export { $EventCount } from './schemas/$EventCount';
export { $EventLineChart } from './schemas/$EventLineChart';
export { $EventMetric } from './schemas/$EventMetric';
export { $EventMetricList } from './schemas/$EventMetricList';
export { $ExpansionNavigationItem } from './schemas/$ExpansionNavigationItem';
export { $Expense } from './schemas/$Expense';
export { $ExpenseList } from './schemas/$ExpenseList';
export { $ExpirationNotification } from './schemas/$ExpirationNotification';
export { $FacilityStatistics } from './schemas/$FacilityStatistics';
export { $FavoriteCategories } from './schemas/$FavoriteCategories';
export { $FavoriteCategory } from './schemas/$FavoriteCategory';
export { $FavoriteItem } from './schemas/$FavoriteItem';
export { $FavoriteItems } from './schemas/$FavoriteItems';
export { $FCMTokenRequest } from './schemas/$FCMTokenRequest';
export { $FCMTokenResponse } from './schemas/$FCMTokenResponse';
export { $Floor } from './schemas/$Floor';
export { $FloorOrder } from './schemas/$FloorOrder';
export { $Floors } from './schemas/$Floors';
export { $Form } from './schemas/$Form';
export { $Forms } from './schemas/$Forms';
export { $FullPatientCalendar } from './schemas/$FullPatientCalendar';
export { $FullPatientCalendarEvents } from './schemas/$FullPatientCalendarEvents';
export { $GetDepartmentCategoriesRequestBody } from './schemas/$GetDepartmentCategoriesRequestBody';
export { $GetDepartmentTitlesRequestBody } from './schemas/$GetDepartmentTitlesRequestBody';
export { $GetDepartmentTitlesResponseBody } from './schemas/$GetDepartmentTitlesResponseBody';
export { $getEmployeeDocumentByAprovalRequest } from './schemas/$getEmployeeDocumentByAprovalRequest';
export { $GetRecentlyJoinedEmployeesResponseBody } from './schemas/$GetRecentlyJoinedEmployeesResponseBody';
export { $GetTarfRequestDetailResponse } from './schemas/$GetTarfRequestDetailResponse';
export { $GetTarfRequestsListResponseBody } from './schemas/$GetTarfRequestsListResponseBody';
export { $GetTarfRequestStatusesResponse } from './schemas/$GetTarfRequestStatusesResponse';
export { $GroupAdmin } from './schemas/$GroupAdmin';
export { $GroupParticipants } from './schemas/$GroupParticipants';
export { $GuardianAngel } from './schemas/$GuardianAngel';
export { $GuardianAngelResponse } from './schemas/$GuardianAngelResponse';
export { $GuardianAngels } from './schemas/$GuardianAngels';
export { $Handbook } from './schemas/$Handbook';
export { $HandbookCategory } from './schemas/$HandbookCategory';
export { $HandbookCategoryDetails } from './schemas/$HandbookCategoryDetails';
export { $HandbookCategoryResponse } from './schemas/$HandbookCategoryResponse';
export { $HandbookCategoryResponseList } from './schemas/$HandbookCategoryResponseList';
export { $HandbookSubCategory } from './schemas/$HandbookSubCategory';
export { $IdName } from './schemas/$IdName';
export { $Inspection } from './schemas/$Inspection';
export { $InspectionDashboardReport } from './schemas/$InspectionDashboardReport';
export { $InspectionData } from './schemas/$InspectionData';
export { $InspectionRequest } from './schemas/$InspectionRequest';
export { $InspectionSummaries } from './schemas/$InspectionSummaries';
export { $InspectionSummary } from './schemas/$InspectionSummary';
export { $ItemMissed } from './schemas/$ItemMissed';
export { $LeastEmployeeDocument } from './schemas/$LeastEmployeeDocument';
export { $LikelyBenefit } from './schemas/$LikelyBenefit';
export { $LikelyBenefits } from './schemas/$LikelyBenefits';
export { $ListAvailableNumber } from './schemas/$ListAvailableNumber';
export { $ListedAnniversary } from './schemas/$ListedAnniversary';
export { $ListedEmployee } from './schemas/$ListedEmployee';
export { $ListEmployeeWithHourSchedule } from './schemas/$ListEmployeeWithHourSchedule';
export { $ListMessageResponse } from './schemas/$ListMessageResponse';
export { $LogEventRequestBody } from './schemas/$LogEventRequestBody';
export { $LoggedEvent } from './schemas/$LoggedEvent';
export { $LoggedEventList } from './schemas/$LoggedEventList';
export { $LoggedEventRecipient } from './schemas/$LoggedEventRecipient';
export { $MaintenanceRequest } from './schemas/$MaintenanceRequest';
export { $MaintenanceRequestResponse } from './schemas/$MaintenanceRequestResponse';
export { $MeEventScoresResponse } from './schemas/$MeEventScoresResponse';
export { $MeRankingResponse } from './schemas/$MeRankingResponse';
export { $Message } from './schemas/$Message';
export { $MessageFile } from './schemas/$MessageFile';
export { $MessageGroup } from './schemas/$MessageGroup';
export { $MessageGroupDetails } from './schemas/$MessageGroupDetails';
export { $MessageGroupList } from './schemas/$MessageGroupList';
export { $MessageGroupRequest } from './schemas/$MessageGroupRequest';
export { $Messages } from './schemas/$Messages';
export { $NavigationItem } from './schemas/$NavigationItem';
export { $NavigationRailItem } from './schemas/$NavigationRailItem';
export { $NavigationSubItem } from './schemas/$NavigationSubItem';
export { $NotifyOnEmployeeDocument } from './schemas/$NotifyOnEmployeeDocument';
export { $NotifyOnEmployeeDocumentResponse } from './schemas/$NotifyOnEmployeeDocumentResponse';
export { $OwnerViewDocumentResponse } from './schemas/$OwnerViewDocumentResponse';
export { $PaginatedMaintenanceResponse } from './schemas/$PaginatedMaintenanceResponse';
export { $PatientCalendar } from './schemas/$PatientCalendar';
export { $PatientCensus } from './schemas/$PatientCensus';
export { $PostBudget } from './schemas/$PostBudget';
export { $PPDDetail } from './schemas/$PPDDetail';
export { $PPDRow } from './schemas/$PPDRow';
export { $ProvisionCompanyRequestBody } from './schemas/$ProvisionCompanyRequestBody';
export { $PurchaseNumber } from './schemas/$PurchaseNumber';
export { $Question } from './schemas/$Question';
export { $Questions } from './schemas/$Questions';
export { $RecentlyJoinedGroupedMonth } from './schemas/$RecentlyJoinedGroupedMonth';
export { $Record } from './schemas/$Record';
export { $RegisterAccountRequestBody } from './schemas/$RegisterAccountRequestBody';
export { $ResponseForm } from './schemas/$ResponseForm';
export { $ResponseQuestion } from './schemas/$ResponseQuestion';
export { $ResponseSatisfactionSurveyData } from './schemas/$ResponseSatisfactionSurveyData';
export { $ResponseSurveyData } from './schemas/$ResponseSurveyData';
export { $ResponseSurveyQuestion } from './schemas/$ResponseSurveyQuestion';
export { $ResponseTask } from './schemas/$ResponseTask';
export { $ReviewTarfRequestByOwnerRequestBody } from './schemas/$ReviewTarfRequestByOwnerRequestBody';
export { $ReviewTarfRequestRequestBody } from './schemas/$ReviewTarfRequestRequestBody';
export { $Room } from './schemas/$Room';
export { $RoomGuardianAngel } from './schemas/$RoomGuardianAngel';
export { $RoomOrder } from './schemas/$RoomOrder';
export { $Rooms } from './schemas/$Rooms';
export { $RoomsStatus } from './schemas/$RoomsStatus';
export { $RoomStatus } from './schemas/$RoomStatus';
export { $RoomStatusCount } from './schemas/$RoomStatusCount';
export { $RoomStatusCounts } from './schemas/$RoomStatusCounts';
export { $SatisfactionOverview } from './schemas/$SatisfactionOverview';
export { $SatisfactionOverviewDetails } from './schemas/$SatisfactionOverviewDetails';
export { $SatisfactionSurvey } from './schemas/$SatisfactionSurvey';
export { $SatisfactionSurveyActiveForm } from './schemas/$SatisfactionSurveyActiveForm';
export { $SatisfactionSurveyData } from './schemas/$SatisfactionSurveyData';
export { $SatisfactionSurveyDataResponse } from './schemas/$SatisfactionSurveyDataResponse';
export { $SatisfactionSurveyDetail } from './schemas/$SatisfactionSurveyDetail';
export { $SatisfactionSurveyForm } from './schemas/$SatisfactionSurveyForm';
export { $SatisfactionSurveyQuestion } from './schemas/$SatisfactionSurveyQuestion';
export { $SatisfactionSurveyQuestions } from './schemas/$SatisfactionSurveyQuestions';
export { $SatisfactionSurveyRequest } from './schemas/$SatisfactionSurveyRequest';
export { $SatisfactionSurveySummary } from './schemas/$SatisfactionSurveySummary';
export { $Schedule } from './schemas/$Schedule';
export { $ScheduleCallOff } from './schemas/$ScheduleCallOff';
export { $ScheduleChartData } from './schemas/$ScheduleChartData';
export { $ScheduleDailyReport } from './schemas/$ScheduleDailyReport';
export { $ScheduleDailyTitleReport } from './schemas/$ScheduleDailyTitleReport';
export { $SchedulePPD } from './schemas/$SchedulePPD';
export { $ScheduleSetting } from './schemas/$ScheduleSetting';
export { $ScheduleStatus } from './schemas/$ScheduleStatus';
export { $ScheduleTimeOff } from './schemas/$ScheduleTimeOff';
export { $ScheduleTimeOffRejectRequest } from './schemas/$ScheduleTimeOffRejectRequest';
export { $ScheduleTimeOffRequest } from './schemas/$ScheduleTimeOffRequest';
export { $ScheduleTimeOffUpdateRequest } from './schemas/$ScheduleTimeOffUpdateRequest';
export { $ScheduleTransfer } from './schemas/$ScheduleTransfer';
export { $ScheduleTransferStatus } from './schemas/$ScheduleTransferStatus';
export { $ScoreboardBreakdown } from './schemas/$ScoreboardBreakdown';
export { $ScoreboardBreakdownEmployeeScores } from './schemas/$ScoreboardBreakdownEmployeeScores';
export { $ScoreboardEventBreakdown } from './schemas/$ScoreboardEventBreakdown';
export { $ScoreboardEventBreakdownDates } from './schemas/$ScoreboardEventBreakdownDates';
export { $ScoreboardEventBreakdownEmployeeScore } from './schemas/$ScoreboardEventBreakdownEmployeeScore';
export { $ScoreboardEventBreakdownListDates } from './schemas/$ScoreboardEventBreakdownListDates';
export { $ScoreboardSummary } from './schemas/$ScoreboardSummary';
export { $ScoreboardSummaryList } from './schemas/$ScoreboardSummaryList';
export { $ScoreboardSummaryScore } from './schemas/$ScoreboardSummaryScore';
export { $SendPasswordResetLinkResponse } from './schemas/$SendPasswordResetLinkResponse';
export { $SendResetPasswordLinkBySelfRequest } from './schemas/$SendResetPasswordLinkBySelfRequest';
export { $SendScheduleSMSResponse } from './schemas/$SendScheduleSMSResponse';
export { $SetCompanyFeatureRequest } from './schemas/$SetCompanyFeatureRequest';
export { $SettingsPayload } from './schemas/$SettingsPayload';
export { $Shift } from './schemas/$Shift';
export { $ShiftBid } from './schemas/$ShiftBid';
export { $ShiftBidStatus } from './schemas/$ShiftBidStatus';
export { $ShiftBidWithSchedule } from './schemas/$ShiftBidWithSchedule';
export { $SmsMessage } from './schemas/$SmsMessage';
export { $SortDepartmentTitlesRequestBody } from './schemas/$SortDepartmentTitlesRequestBody';
export { $StaffSurveyCategory } from './schemas/$StaffSurveyCategory';
export { $StaffSurveyCodeRequest } from './schemas/$StaffSurveyCodeRequest';
export { $StaffSurveyDataForDetails } from './schemas/$StaffSurveyDataForDetails';
export { $StaffSurveyForm } from './schemas/$StaffSurveyForm';
export { $StaffSurveyFormQuestion } from './schemas/$StaffSurveyFormQuestion';
export { $StaffSurveyFormResponse } from './schemas/$StaffSurveyFormResponse';
export { $StaffSurveyOverview } from './schemas/$StaffSurveyOverview';
export { $StaffSurveyOverviewDetail } from './schemas/$StaffSurveyOverviewDetail';
export { $StaffSurveyQuestion } from './schemas/$StaffSurveyQuestion';
export { $StaffSurveyQuestionAndAnswer } from './schemas/$StaffSurveyQuestionAndAnswer';
export { $StaffSurveyQuestionForDetails } from './schemas/$StaffSurveyQuestionForDetails';
export { $StaffSurveyQuestionList } from './schemas/$StaffSurveyQuestionList';
export { $StaffSurveyQuestionOption } from './schemas/$StaffSurveyQuestionOption';
export { $StaffSurveyQuestionWithOptions } from './schemas/$StaffSurveyQuestionWithOptions';
export { $StaffSurveyResponseData } from './schemas/$StaffSurveyResponseData';
export { $StaffSurveyResponseWithDetails } from './schemas/$StaffSurveyResponseWithDetails';
export { $StaffSurveySubmission } from './schemas/$StaffSurveySubmission';
export { $StaffSurveySubmissionDetails } from './schemas/$StaffSurveySubmissionDetails';
export { $StaffSurveySubmissionWithCode } from './schemas/$StaffSurveySubmissionWithCode';
export { $StaffSurveySubmissionWithResponses } from './schemas/$StaffSurveySubmissionWithResponses';
export { $Statistics } from './schemas/$Statistics';
export { $SubStatistics } from './schemas/$SubStatistics';
export { $Suggestion } from './schemas/$Suggestion';
export { $SuggestionAnswer } from './schemas/$SuggestionAnswer';
export { $SuggestionQuestion } from './schemas/$SuggestionQuestion';
export { $SuggestionQuestions } from './schemas/$SuggestionQuestions';
export { $Suggestions } from './schemas/$Suggestions';
export { $SurveyData } from './schemas/$SurveyData';
export { $SurveyDataDetail } from './schemas/$SurveyDataDetail';
export { $SurveyDetail } from './schemas/$SurveyDetail';
export { $SurveyOverviewDetail } from './schemas/$SurveyOverviewDetail';
export { $SurveyOverviewDetails } from './schemas/$SurveyOverviewDetails';
export { $SurveyQuestion } from './schemas/$SurveyQuestion';
export { $SurveyQuestions } from './schemas/$SurveyQuestions';
export { $SurveyRequest } from './schemas/$SurveyRequest';
export { $SurveySummary } from './schemas/$SurveySummary';
export { $TarfDetail } from './schemas/$TarfDetail';
export { $TarfEditRequestBody } from './schemas/$TarfEditRequestBody';
export { $TarfListItem } from './schemas/$TarfListItem';
export { $TarfReason } from './schemas/$TarfReason';
export { $TarfReasonsResponseBody } from './schemas/$TarfReasonsResponseBody';
export { $TarfRequestRequestBody } from './schemas/$TarfRequestRequestBody';
export { $TarfRequestsGroupedMonth } from './schemas/$TarfRequestsGroupedMonth';
export { $TarfRequestsGroupedYear } from './schemas/$TarfRequestsGroupedYear';
export { $TarfResubmitRequestBody } from './schemas/$TarfResubmitRequestBody';
export { $TarfStatusDetail } from './schemas/$TarfStatusDetail';
export { $Task } from './schemas/$Task';
export { $Tasks } from './schemas/$Tasks';
export { $TermsAndCondition } from './schemas/$TermsAndCondition';
export { $TermsAndConditionList } from './schemas/$TermsAndConditionList';
export { $TermsAndConditionListRequest } from './schemas/$TermsAndConditionListRequest';
export { $TermsAndConditionRequest } from './schemas/$TermsAndConditionRequest';
export { $TestNotificationRequest } from './schemas/$TestNotificationRequest';
export { $TestNotificationResponse } from './schemas/$TestNotificationResponse';
export { $TimeOffStatus } from './schemas/$TimeOffStatus';
export { $TitleSchedulePPD } from './schemas/$TitleSchedulePPD';
export { $ToggleLoggedEventRequestBody } from './schemas/$ToggleLoggedEventRequestBody';
export { $Track } from './schemas/$Track';
export { $TrackedEventMetricsByDepartment } from './schemas/$TrackedEventMetricsByDepartment';
export { $TrackRecords } from './schemas/$TrackRecords';
export { $TransferEmployeeToDepartmentRequest } from './schemas/$TransferEmployeeToDepartmentRequest';
export { $UnattendedRooms } from './schemas/$UnattendedRooms';
export { $UnreadCount } from './schemas/$UnreadCount';
export { $UpdateCompanyEmployeeRolesRequest } from './schemas/$UpdateCompanyEmployeeRolesRequest';
export { $UpdateEmployeeProfileRequest } from './schemas/$UpdateEmployeeProfileRequest';
export { $UpdateScheduleTransferStatusRequest } from './schemas/$UpdateScheduleTransferStatusRequest';
export { $Vacation } from './schemas/$Vacation';
export { $VacationListResponse } from './schemas/$VacationListResponse';
export { $VacationRequest } from './schemas/$VacationRequest';

export { AdminService } from './services/AdminService';
export { AnnouncementService } from './services/AnnouncementService';
export { AuthService } from './services/AuthService';
export { BedService } from './services/BedService';
export { CalendarService } from './services/CalendarService';
export { CompaniesService } from './services/CompaniesService';
export { CompanyFeaturesService } from './services/CompanyFeaturesService';
export { CountDocumentService } from './services/CountDocumentService';
export { CronJobService } from './services/CronJobService';
export { DepartmentColorService } from './services/DepartmentColorService';
export { DepartmentDocumentService } from './services/DepartmentDocumentService';
export { DepartmentService } from './services/DepartmentService';
export { DepartmentsService } from './services/DepartmentsService';
export { DocumentNameService } from './services/DocumentNameService';
export { EmployeeDocumentNotificationService } from './services/EmployeeDocumentNotificationService';
export { EmployeeDocumentService } from './services/EmployeeDocumentService';
export { EmployeesService } from './services/EmployeesService';
export { EventLogService } from './services/EventLogService';
export { EventMetricsService } from './services/EventMetricsService';
export { ExpenseService } from './services/ExpenseService';
export { FacilityStatisticsService } from './services/FacilityStatisticsService';
export { FavoriteCategoryService } from './services/FavoriteCategoryService';
export { FloorService } from './services/FloorService';
export { GuardianAngelService } from './services/GuardianAngelService';
export { HandbookService } from './services/HandbookService';
export { HelloService } from './services/HelloService';
export { InspectionService } from './services/InspectionService';
export { MaintenanceRequestService } from './services/MaintenanceRequestService';
export { MessageService } from './services/MessageService';
export { PatientCalendarService } from './services/PatientCalendarService';
export { PatientCensusService } from './services/PatientCensusService';
export { PhysicianService } from './services/PhysicianService';
export { QuestionService } from './services/QuestionService';
export { RoomService } from './services/RoomService';
export { SchedulePpdService } from './services/SchedulePpdService';
export { ScheduleService } from './services/ScheduleService';
export { ScheduleTimeOffService } from './services/ScheduleTimeOffService';
export { ScheduleTransferService } from './services/ScheduleTransferService';
export { ScoreboardService } from './services/ScoreboardService';
export { ShiftService } from './services/ShiftService';
export { SmsService } from './services/SmsService';
export { StaffSurveyService } from './services/StaffSurveyService';
export { SuggestionService } from './services/SuggestionService';
export { SurveyService } from './services/SurveyService';
export { TarfService } from './services/TarfService';
export { TaskService } from './services/TaskService';
export { TermsAndConditionService } from './services/TermsAndConditionService';
export { VacationsService } from './services/VacationsService';
